import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=5d851beb&scoped=true&"
import script from "./basicInfo.vue?vue&type=script&lang=js&"
export * from "./basicInfo.vue?vue&type=script&lang=js&"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=5d851beb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d851beb",
  null
  
)

export default component.exports